export default (value, field) => ({ form, status }) => {
  const list = form.casts.value;
  const cast = list.filter(item => {
    return item[field] !== value;
  });
  form.casts.value = cast;
  return { form, status };
};
